import {
  SYNC_RESUME_DATA_REQUEST,
  SYNC_RESUME_DATA_SUCCESS,
  SYNC_RESUME_DATA_FAILURE,
  RESET_SYNC_RESUME_DATA,
} from "../../actionTypes";

export const syncResumeDataRequest = (data) => ({
  type: SYNC_RESUME_DATA_REQUEST,
  payload: data,
});

export const syncResumeDataSuccess = (data) => ({
  type: SYNC_RESUME_DATA_SUCCESS,
  payload: data,
});

export const syncResumeDataFailure = (error) => ({
  type: SYNC_RESUME_DATA_FAILURE,
  payload: error,
});

export const resetSyncResumeData = () => ({
  type: RESET_SYNC_RESUME_DATA,
}); 